"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fastXmlParser = _interopRequireDefault(require("fast-xml-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VULCAN_PREFIX = 'vulcan.SuiteMessage.';
var notificationMessageName = "".concat(VULCAN_PREFIX, "accc.notifications");
var requestorNamespace = 'ccx.notifications.comments';
var getDataRequestorNamespace = "".concat(requestorNamespace, ".getDataById");
var eventListenerNamespace = "".concat(VULCAN_PREFIX).concat(requestorNamespace);
var getDataEventListenerNamespace = "".concat(VULCAN_PREFIX).concat(getDataRequestorNamespace);
/**
 * VulcanHandler class for interacting with Vulcan
 */

var VulcanHandler = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param {Function} onNotificationAssetMatch - handler for when a notification with matching ID is recieved
   */
  function VulcanHandler(onNotificationAssetMatch) {
    _classCallCheck(this, VulcanHandler);

    var uxpVulcan = window.require('uxp').vulcan;

    this._dispatcher = uxpVulcan.dispatcher;
    this._message = uxpVulcan.message;
    this._assetId = '';
    this._onNotificationAssetMatch = onNotificationAssetMatch;

    this._dispatcher.addEventListener(eventListenerNamespace, this.handleNotificationMessage.bind(this));

    this._dispatcher.addEventListener(getDataEventListenerNamespace, this.handleDataMessage.bind(this));

    var newCommentNotificationPayload = "\n      <NEMessage action=\"RegisterObserver\">\n        <type>com.adobe.stormcloud.v1</type>\n        <sub-type>notification.asset.comment</sub-type>\n        <observer-namespace>".concat(requestorNamespace, "</observer-namespace>\n        <request-context>").concat(requestorNamespace, "</request-context>\n      </NEMessage>\n    ");

    this._dispatcher.broadcastMessage(new this._message(notificationMessageName, newCommentNotificationPayload));

    var otherActionsNotificationPayload = "\n      <NEMessage action=\"RegisterObserver\">\n        <type>com.adobe.accc.generic.v1</type>\n        <sub-type>com.adobe.redhawk.comment_notify</sub-type>\n        <observer-namespace>".concat(requestorNamespace, "</observer-namespace>\n        <request-context>").concat(requestorNamespace, "</request-context>\n      </NEMessage>\n    ");

    this._dispatcher.broadcastMessage(new this._message(notificationMessageName, otherActionsNotificationPayload));
  }
  /**
   * Setter for asset ID
   * @param {string} value - new asset ID value
   * @returns {undefined}
   */


  _createClass(VulcanHandler, [{
    key: "handleNotificationMessage",

    /**
     * Handles CCD notification event
     * @param {string} payload - Notification XML string
     * @returns {undefined}
     */
    value: function handleNotificationMessage(_ref) {
      var _xmlNotification$noti,
          _xmlNotification$noti2,
          _xmlNotification$noti3,
          _xmlNotification$noti4,
          _xmlNotification$noti5,
          _xmlNotification$noti6,
          _this = this;

      var payload = _ref.payload;

      var xmlNotification = _fastXmlParser["default"].parse(payload, {
        arrayMode: true
      });

      var notifications = xmlNotification === null || xmlNotification === void 0 ? void 0 : (_xmlNotification$noti = xmlNotification['notifications-signal']) === null || _xmlNotification$noti === void 0 ? void 0 : (_xmlNotification$noti2 = _xmlNotification$noti[0]) === null || _xmlNotification$noti2 === void 0 ? void 0 : (_xmlNotification$noti3 = _xmlNotification$noti2['notification-signal']) === null || _xmlNotification$noti3 === void 0 ? void 0 : (_xmlNotification$noti4 = _xmlNotification$noti3[0]) === null || _xmlNotification$noti4 === void 0 ? void 0 : (_xmlNotification$noti5 = _xmlNotification$noti4['notification-info']) === null || _xmlNotification$noti5 === void 0 ? void 0 : (_xmlNotification$noti6 = _xmlNotification$noti5[0]) === null || _xmlNotification$noti6 === void 0 ? void 0 : _xmlNotification$noti6['notification-ids'];
      notifications.forEach(function (notificationData) {
        var notificationId = notificationData['notification-id'];
        var messagePayload = "\n        <NEMessage action=\"GetDataByID\">\n          <notification-ids>\n            <notification-id>".concat(notificationId, "</notification-id>\n          </notification-ids>\n          <request-context>").concat(getDataRequestorNamespace, "</request-context>\n          <requestor-namespace>").concat(requestorNamespace, ".getDataById</requestor-namespace>\n        </NEMessage>\n      ");

        _this._dispatcher.broadcastMessage(new _this._message(notificationMessageName, messagePayload));
      });
    }
    /**
     * Handles notification detail event
     * @param {string} payload - Notification detail XML string
     * @returns {undefined}
     */

  }, {
    key: "handleDataMessage",
    value: function handleDataMessage(_ref2) {
      var _xmlNotification$noti7, _xmlNotification$noti8, _xmlNotification$noti9, _xmlNotification$noti10;

      var payload = _ref2.payload;

      var xmlNotification = _fastXmlParser["default"].parse(payload, {
        arrayMode: true
      });

      var notificationPayload = (xmlNotification === null || xmlNotification === void 0 ? void 0 : (_xmlNotification$noti7 = xmlNotification.notifications) === null || _xmlNotification$noti7 === void 0 ? void 0 : (_xmlNotification$noti8 = _xmlNotification$noti7[0]) === null || _xmlNotification$noti8 === void 0 ? void 0 : (_xmlNotification$noti9 = _xmlNotification$noti8.notification) === null || _xmlNotification$noti9 === void 0 ? void 0 : (_xmlNotification$noti10 = _xmlNotification$noti9[0]) === null || _xmlNotification$noti10 === void 0 ? void 0 : _xmlNotification$noti10.payload) || '';

      var assetIdParts = this._assetId.split(':');

      if (notificationPayload.includes(assetIdParts[assetIdParts.length - 1])) {
        this._onNotificationAssetMatch();
      }
    }
  }, {
    key: "assetId",
    set: function set(value) {
      this._assetId = value;
    }
  }]);

  return VulcanHandler;
}();

var _default = VulcanHandler;
exports["default"] = _default;